import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { ApolloClient, ApolloProvider, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import App from './App';
import './index.css';

const httpLink = createHttpLink({
  uri: process.env.REACT_APP_GQL_BASE_URL || 'http://localhost:4000/graphql',
});

const authLink = setContext((_, { headers }) => {
  let token;
  // get the current user from local storage
  const currentUser = localStorage.getItem('coe-current-user');
  // get the authentication token from local storage if it exists
  if (currentUser === 'student') {
    token = localStorage.getItem('coe-student-token');
  } else if (currentUser === 'invigilator') {
    token = localStorage.getItem('coe-invigilator-token');
  } else {
    token = localStorage.getItem('coe-admin-token');
  }

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: authLink.concat(httpLink),
});

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={apolloClient}>
      <App />
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
